import CONST_STORAGE from 'constants/storage';

export const setStorageWebUserData = (item: string) =>
  localStorage.setItem(CONST_STORAGE.WEB_USER.DATA, item);

export const getStorageWebUserData = () =>
  localStorage.getItem(CONST_STORAGE.WEB_USER.DATA) || JSON.stringify({});
